<script setup>
import {ref, onMounted, defineProps, defineExpose, watch, onUnmounted, nextTick, inject} from 'vue';
import { isIOS } from '@basitcodeenv/vue3-device-detect';
import { useWindowSize } from '@vueuse/core';
//import AudioPlayer from '@/components/AudioComponent';
const { width } = useWindowSize();
import axios from 'axios';
import VideoBackground from 'vue-responsive-video-background-player';
import LoaderBlock from "@/components/LoaderBlock";
import InputAutocomplete from "@/components/InputAutocomplete";
import start from "@/assets/animations/start.json";
import start_hover from "@/assets/animations/start_hover.json";
import taste from "@/assets/animations/taste.json";
import warm from "@/assets/animations/warm.json";
import unusual from "@/assets/animations/warm.json";
import taste_hover from "@/assets/animations/taste_hover.json";
import warm_hover from "@/assets/animations/warm_hover.json";
import unusual_hover from "@/assets/animations/warm_hover.json";
import creamy from "@/assets/animations/creamy.json";
import creamy_hover from "@/assets/animations/creamy_hover.json";
import honey from "@/assets/animations/honey.json";
import honey_hover from "@/assets/animations/honey_hover.json";
import nutty from "@/assets/animations/nutty.json";
import nutty_hover from "@/assets/animations/nutty_hover.json";
import berry from "@/assets/animations/berry.json";
import berry_hover from "@/assets/animations/berry_hover.json";
import citrus from "@/assets/animations/citrus.json";
import citrus_hover from "@/assets/animations/citrus_hover.json";
import pumpkin from "@/assets/animations/pumpkin.json";
import pumpkin_hover from "@/assets/animations/pumpkin_hover.json";
import cup1 from "@/assets/animations/cup1.json";
import cup2 from "@/assets/animations/cup2.json";
import final from "@/assets/animations/final.json";

import taste_spring from "@/assets/animations/taste.json";
import taste_spring_hover from "@/assets/animations/taste_hover.json";
import creamy_spring from "@/assets/animations/creamy_spring.json";
import creamy_spring_hover from "@/assets/animations/creamy_spring_hover.json";
import honey_spring from "@/assets/animations/honey_spring.json";
import honey_spring_hover from "@/assets/animations/honey_spring_hover.json";
import berry_unusual_spring from "@/assets/animations/berry_spring.json";
import berry_taste_spring from "@/assets/animations/berry_spring.json";
import berry_unusual_spring_hover from "@/assets/animations/berry_spring_hover.json";
import berry_taste_spring_hover from "@/assets/animations/berry_spring_hover.json";
import citrus_spring from "@/assets/animations/citrus_spring.json";
import citrus_spring_hover from "@/assets/animations/citrus_spring_hover.json";
import fruit_spring from "@/assets/animations/fruit_spring.json";
import fruit_spring_hover from "@/assets/animations/fruit_spring_hover.json";
import final_s from "@/assets/animations/final-s.json";

const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  }
});

//const audioRef = ref(null);
//const isPlaying = ref(false);
const videoRef = ref(null);
const isLoading = ref(true);
const selectedName = ref(undefined);
const step = ref(1);
const videoMuted = ref(true);
const selectedMood = ref(undefined);
const selectedTaste = ref(undefined);
const urlString = window.location.origin;
const nameVideoExist = ref(false);

const timer = ref(null)

const postfix = props.data.quiz === 's2026' ? '-s' : '';

const getVideo = (step) => {
  if (step === 6 && nameVideoExist.value) {
    return `/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/${selectedName.value?.file}.mp4`;
  }
  if (step === 5 || step === 7) {
    return `/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/video${step}-${selectedTaste.value}.mp4`;
  }
  return `/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/video${step}${postfix}.mp4`;
}

const checkVideo = async () => {
  if (!selectedName.value?.file) return;
  try {
    const response = await axios.head(`/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/${selectedName.value?.file}.mp4`);
    if (response.status === 200) {
      nameVideoExist.value = true;
    }
  } catch (err) {
    nameVideoExist.value = false;
  }
};

const startVideo = () => {
  /*if (!isIOS || step.value > 1) {
    isLoading.value = false;
    clearTimeout(timer.value);
    nextTick(() => {
      videoRef.value.player.play();
    })
  } else {
    if (playerStatus.value) {
      isLoading.value = false;
      clearTimeout(timer.value);
      videoRef.value.player.play();
    }
  }*/
  isLoading.value = false;
  clearTimeout(timer.value);
  nextTick(() => {
    videoRef.value.player.play();
  })
}

watch(selectedName, () => {
  if (selectedName.value?.file && selectedName.value?.file !== 'other') {
    checkVideo();
  }
})

const next = (val) => {
  isLoading.value = true;
  step.value = val;
  clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    if (step.value > 3 && step.value < 8) {
      startVideo();
    }
  }, 10000)
}

const videoEnded = () => {
  const videoElement = videoRef.value.$el.querySelector('video');
  if (step.value !== 1 && step.value !== 2 && step.value !== 3 && step.value !== 8) {
    next(step.value + 1);
  }
  if (step.value === 1) {
    videoElement.currentTime = props.data.quiz === 's2026' ? 17 : 8;
    videoElement.play();
  }
  if (step.value === 2) {
    videoElement.currentTime = 3;
    videoElement.play();
  }
  if (step.value === 3) {
    videoElement.currentTime = 4;
    videoElement.play();
  }
  if (step.value === 8) {
    videoElement.currentTime = 11;
    videoElement.play();
  }
}

const toggleVolume = () => {
  if (videoRef.value && videoRef.value.$el) {
    const videoElement = videoRef.value.$el.querySelector('video');
    if (videoElement) {
      videoElement.muted = !videoMuted.value;
      videoMuted.value = !videoMuted.value;
      if (!videoMuted.value) {
        videoElement.currentTime = 0;
        videoElement.play();
      }
    }
  }

  /*if (!isIOS) {
    if (videoMuted.value) {
      audioRef.value.pause();
      isPlaying.value = false;
    } else {
      audioRef.value.muted = false;
      audioRef.value.play();
      isPlaying.value = true;
    }
  } else {
    if (videoMuted.value) {
      handlePause()
    } else {
      handlePlay()
    }
  }*/
}

const nextAnimationActive = ref(false)

const showSecondAnimation = () => {
  nextAnimationActive.value = true;
}

const animationMap = {
  taste, taste_hover, warm, warm_hover, creamy, creamy_hover, honey, honey_hover, nutty, nutty_hover, berry, berry_hover, citrus, citrus_hover, pumpkin, pumpkin_hover, taste_spring, taste_spring_hover, unusual, unusual_hover, berry_unusual_spring, berry_unusual_spring_hover, creamy_spring, creamy_spring_hover, fruit_spring, fruit_spring_hover, honey_spring, honey_spring_hover, citrus_spring, citrus_spring_hover, berry_taste_spring, berry_taste_spring_hover
}
const hasAnimation = (id) => {
  const fixedId = id.replaceAll('-', '_');
  return fixedId in animationMap
}

const getAnimationData = (id) => {
  const fixedId = id.replaceAll('-', '_');
  return animationMap[fixedId]
}

const returnToFirstStep = () => {
  step.value = 1;
  clearTimeout(timer.value);
  selectedName.value = undefined;
  nameVideoExist.value = false;
}

defineExpose({
  returnToFirstStep
})

const DLEvent = inject('DLEvent')


//const playerStatus = ref('')

/*const handlePlay = () => {
  if (audioRef.value) {
    audioRef.value.play()
  }
}

const handlePause = () => {
  if (audioRef.value) {
    audioRef.value.pause()
  }
}

const handleStatusUpdate = (status) => {
  playerStatus.value = status
  if (status === 'ready') {
    startVideo();
  }
}

const handleEnded = () => {
  playerStatus.value = 'ended'
  if (!videoMuted.value) {
    handlePlay();
  }
}*/

onMounted(() => {
  /*if (!isIOS) {
    audioRef.value.volume = 0.3;
  }*/
});

onUnmounted(() => {
  clearTimeout(timer.value);
  /*if (audioRef.value) {
    audioRef.value.pause();
    audioRef.value = null;
  }*/
});
</script>

<template>
  <Transition>
    <LoaderBlock v-if="isLoading" :transition="step > 1"/>
  </Transition>
  <div :class="['quiz', {'quiz_first-screen': step === 1}]">
    <img :src="require(`@/assets/video/poster${step}${postfix}.jpg`)" alt="" class="quiz__video-placeholder">
    <video-background
        :src="getVideo(step)"
        class="quiz__video"
        @ready="startVideo"
        :autoplay="true"
        ref="videoRef"
        playsWhen="canplaythrough"
        :key="`video${step}`"
        :loop="false"
        @ended="videoEnded"
        :muted="videoMuted"
        :poster="require(`@/assets/video/poster${step}${postfix}.jpg`)"
    ></video-background>
    <img :src="require('@/assets/img/shadow.png')" alt="" style="position: absolute; width: 0; height: 0;">
    <img :src="require(`@/assets/video/poster${step + 1}${postfix}.jpg`)" alt="" style="position: absolute; width: 0; height: 0;" v-if="step < 8" :key="`preload-image${step}`">
    <div style="width: 0; height: 0; overflow: hidden; position: fixed; top: 0; left: 0;" v-if="step < 8 && !isIOS" :key="`preload-video${step}`">
      <video preload="auto" muted style="width: 100%; height: 100%" v-if="step === 4">
        <source :src="`/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/video${step + 1}-${selectedTaste}.mp4`" type="video/mp4">
      </video>
      <video preload="auto" muted style="width: 100%; height: 100%" v-else-if="step === 5 && nameVideoExist">
        <source :src="`/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/${selectedName?.file}.mp4`" type="video/mp4">
      </video>
      <video preload="auto" muted style="width: 100%; height: 100%" v-else-if="step === 6">
        <source :src="`/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/video${step + 1}-${selectedTaste}.mp4`" type="video/mp4">
      </video>
      <video preload="auto" muted style="width: 100%; height: 100%" v-else>
        <source :src="`/modules/custom/nescafe_videoquiz/app/assets/video/videoquiz/video${step + 1}.mp4`" type="video/mp4">
      </video>
    </div>
    <div :class="['quiz__main', `_step${step}`]" v-if="!isLoading">

      <template v-if="step === 2">
        <div class="quiz__main-options">
          <a
              href=""
              v-for="(mood, index) in Object.values(data.selections)"
              @click.prevent="selectedMood = mood.id; next(3); DLEvent(`festive_get_${mood.id}`)"
              class="animated-button animated-button_option1 fade-in"
              :key="mood.id"
              :style="{'animation-delay': `${1 + index/2}s`}"
          >
            <Vue3Lottie
                v-if="hasAnimation(mood.id)"
                :animationData="getAnimationData(mood.id)"
                :delay="1000 + (index/2*1000)"
                :loop="false"
                class="_main"
            />
            <Vue3Lottie
                v-if="hasAnimation(`${mood.id}_hover`)"
                :animationData="getAnimationData(`${mood.id}_hover`)"
                :delay="1000 + (index/2*1000)"
                :loop="false"
                class="_hover"
            />
            <span>{{ mood.title }}</span>
          </a>
        </div>
      </template>

      <template v-if="step === 3">
        <div class="quiz__main-options">
          <a
              href=""
              v-for="(taste, index) in Object.values(data.selections[selectedMood]['childs'])"
              @click.prevent="selectedTaste = taste.id; next(4); DLEvent('festive_taste_choose', 'taste', taste.title)"
              class="animated-button animated-button_option2 fade-in"
              :key="taste.id"
              :style="{'animation-delay': `${1 + index/2}s`}"
          >
            <Vue3Lottie
                v-if="hasAnimation(taste.id)"
                :animationData="getAnimationData(taste.id)"
                :loop="false"
                :delay="1000 + (index/2*1000)"
                class="_main"
            />
            <Vue3Lottie
                v-if="hasAnimation(`${taste.id}_hover`)"
                :animationData="getAnimationData(`${taste.id}_hover`)"
                class="_hover"
            />
            <span>{{ taste.title }}</span>
          </a>
        </div>
      </template>

      <template v-if="step === 8">
        <div class="quiz__main-options">
          <a
            :href="`${urlString}/videoquiz/${data.quiz}/${selectedTaste}/${selectedName?.file || 'other'}`"
            class="animated-button animated-button_final"
            @click="DLEvent('festive_get_gift')"
          >
            <Vue3Lottie :animationData="taste" class="_main" :loop="false"/>
            <Vue3Lottie :animationData="data.quiz === 's2026' ? final_s : final" class="_hover" :loop="false"/>
            <span>Забрать<br/>подарок</span>
          </a>
        </div>
      </template>

      <span v-if="step === 1 && width <= 730 && videoMuted" class="quiz__sound-note">
        <span>Включить звук</span>
      </span>

      <a href="" @click.prevent="toggleVolume" :class="['quiz__sound', {'quiz__sound_off': videoMuted}]">
        <img :src="require('@/assets/img/sound-off.svg')" alt="Включить звук" v-show="videoMuted">
        <inline-svg :src="require('@/assets/img/sound-on.svg')"  v-show="!videoMuted"></inline-svg>
      </a>

      <template v-if="step === 1">
        <div class="quiz__main-text">
          <p>Привет! Давай я приготовлю коктейль на&nbsp;основе кофе <b>НЕСКАФЕ® <span>ГОЛД</span></b> специально для&nbsp;тебя?</p>
        </div>
        <InputAutocomplete v-model="selectedName" :names="data.names" />
        <a href="" @click.prevent="next(2); DLEvent('festive_get_cocktail')" class="animated-button quiz__button">
          <Vue3Lottie :animationData="start" class="_main" :loop="false"/>
          <Vue3Lottie :animationData="start_hover" class="_hover" :loop="false"/>
          <span>получить коктейль</span>
        </a>
      </template>

      <template v-if="step === 2">
        <div class="quiz__main-text fade-in">
          <p>Рад знакомству!<br/> Какое у тебя настроение?</p>
        </div>
      </template>

      <template v-if="step === 3">
        <div class="quiz__main-text fade-in">
          <p>Отлично!<br/>Добавим яркую нотку?</p>
        </div>
      </template>

      <template v-if="step === 4">
        <div class="quiz__main-text fade-in">
          <p>Теперь немного магии... </p>
        </div>
        <div class="quiz__icon" v-if="width < 730">
          <Vue3Lottie :animationData="cup1" @onComplete="showSecondAnimation" :loop="false" v-if="!nextAnimationActive"/>
          <Vue3Lottie :animationData="cup2" v-else/>
        </div>
      </template>

      <template v-if="step === 5">
        <div class="quiz__icon" v-if="width < 730">
          <Vue3Lottie :animationData="cup1" @onComplete="showSecondAnimation" :loop="false" v-if="!nextAnimationActive"/>
          <Vue3Lottie :animationData="cup2" v-else/>
        </div>
      </template>

      <template v-if="step === 6">
        <div class="quiz__main-text fade-in">
          <p>
            <template v-if="selectedName?.name && selectedName?.file !== 'other'">{{ selectedName.name }}, все готово!</template>
            <template v-else>Все готово!</template>
          </p>
        </div>
        <div class="quiz__icon" v-if="width < 730">
          <Vue3Lottie :animationData="cup1" @onComplete="showSecondAnimation" :loop="false" v-if="!nextAnimationActive"/>
          <Vue3Lottie :animationData="cup2" v-else/>
        </div>
      </template>

      <template v-if="step === 7">
        <div class="quiz__main-text fade-in">
          <p>Коктейль «{{ data.selections?.[selectedMood]?.['childs']?.[selectedTaste]?.recipe }}» я&nbsp;приготовил специально для тебя!</p>
        </div>
        <div class="quiz__icon" v-if="width < 730">
          <Vue3Lottie :animationData="cup1" @onComplete="showSecondAnimation" :loop="false" v-if="!nextAnimationActive"/>
          <Vue3Lottie :animationData="cup2" v-else/>
        </div>
      </template>

      <template v-if="step === 8">
        <div class="quiz__main-text fade-in">
          <p>И ты легко сможешь повторить его дома.<br/>
            Я и себе кофе сделал...<br/>
            С праздником!</p>
        </div>
      </template>
    </div>
    <!--AudioPlayer
        ref="audioRef"
        @update:status="handleStatusUpdate"
        @ended="handleEnded"
        v-if="isIOS"
    />
    <audio loop ref="audioRef" class="quiz__audio" v-else>
      <source :src="require('@/assets/test.mp3')" type="audio/mpeg">
    </audio -->
  </div>
</template>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>